// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HasSeen":"cn_a bii_fm bii_vv bii_xg bii_h"};